import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router';
import router from './router';
import util from './common/util.js';


// 滑块验证码
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify);

// 赋值到剪贴板
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)



// 自适应element表格
import AFTableColumn from 'af-table-column'
 
Vue.use(AFTableColumn)


Vue.use(VueRouter);
Vue.use(ElementUI);


//	设置全局请求方法
Vue.config.productionTip	=	false;


Vue.prototype.util		=	util;
Vue.prototype.request	=	util.request;
Vue.prototype.upload	=	util.upload;
Vue.prototype.alert		=	util.alert;



 
//	引入封装通用组件库
import comUI from "./layout/index.js";
Vue.use(comUI);


new Vue({

	el: '#app',
	// （此处相当于router:"router"）实例化一个变量
	router,

	render: h => h(App)
});